module.exports = __webpack_public_path__ + "img/pinjia03.2454948d.jpg";